import axios from "axios";
import { returnURL, returnJson } from "../ApiSettings/returnURL";
const BaseUrl = "api/Button/Post";
const LoginBaseUrl = "api/Oauth/Token";
const AccountInfoUrl = "api/Account/Info";
const ConfigInfoUrl = "api/Button/Info";

//Login Api
export async function loginApi(url, phone, pass, prefix) {
  let url_request = url;
  url_request = returnURL(url_request) + LoginBaseUrl;

  const params = JSON.stringify({
    grant_type: "password",
    username: prefix + phone,
    password: pass,
  });

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "cc03e747a6afbbcbf8be7668acfebee5",
    },
    timeout: 60000,
  });
}

export async function getAccountInfo(url, token) {
  let url_request = url;
  url_request = returnURL(url_request) + AccountInfoUrl;

  return await axios.get(url_request, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

export async function getAccountConfig(url, token) {
  let url_request = url;
  url_request = returnURL(url_request) + ConfigInfoUrl;

  return await axios.get(url_request, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}
